<template>
    <div class="recipe--actions">
        <button class="recipe--actions-button" @click="initActions" v-bind:class="{ active: active }">
            <span>Spara</span>
            <svg class="icon icon-down">
                <use xlink:href="#chevron-down"></use>
            </svg>
            <svg class="icon icon-up">
                <use xlink:href="#chevron-up"></use>
            </svg>
        </button>
        <ul class="recipe--actions-list">
            <li v-if="favourite" @click="deleteFavourite">Ta bort från min kokbok</li>
            <li v-else @click="addFavourite">Min Kokbok</li>
            <li v-if="isRecipeAdmin" @click.stop="setMenuFormState">Veckomeny</li>
            <li @click.stop="setFoodDiaryFormState">Min Matdagbok</li>
            <li @click.stop="setGroceryListFormState">Min inköpslista</li>
        </ul>
        <div v-if="response && show" class="modal-popup">
            <svg @click="close" v-if="show" class="icon icon-close">
                <use xlink:href="#icon-close"></use>
            </svg>
            <p>{{ response }}</p>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import state from './../state.js';

export default {
    props: {
        userId: Number,
        recipeId: Number,
        isRecipeAdmin: Boolean,
        isMobile: Boolean,
        ingredients: Array,
        recipeServings: Number
    },

    data() {
        return {
            state,
            active: false,
            favourite: null,
            response: false,
            show: false
        };
    },

    mounted() {
        this.state.isMobile = this.isMobile;
        document.addEventListener('click', this.handleOutsideClick);
    },

    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick);
    },

    methods: {
        setGroceryListFormState() {
            this.state.groceryListForm.active = !this.state.groceryListForm.active;
            this.state.groceryListForm.recipeId = this.recipeId;
            this.state.groceryListForm.ingredients = this.ingredients;
            this.state.groceryListForm.recipeServings = this.recipeServings;

            this.setActive();
        },

        setFoodDiaryFormState() {
            this.state.foodDiaryForm.active = true;
            this.state.foodDiaryForm.recipeId = this.recipeId;
            this.state.foodDiaryForm.servings = this.state.selectedServings;

            this.setActive();
        },

        setMenuFormState() {
            this.state.menuForm = !this.state.menuForm;
            this.setActive();
        },

        setActive() {
            this.active = !this.active;
        },

        addFavourite() {
            const url = '/recept/api/favourite/' + this.userId + '/' + this.recipeId + '/add';
            axios
                .get(url)
                .then((response) => {
                    this.response = response.data.response;
                    this.show = !this.show;
                    $('body').addClass('modal-popup-active');
                })
                .catch((error) => {
                    console.log('get error', error);
                });
        },

        close() {
            this.show = !this.show;
            $('body').removeClass('modal-popup-active');
        },

        deleteFavourite() {
            const url = '/recept/api/favourite/' + this.userId + '/' + this.recipeId + '/delete';
            axios
                .get(url)
                .then((response) => {
                    this.response = response.data.response;
                    this.show = !this.show;
                    $('body').addClass('modal-popup-active');
                })
                .catch((error) => {
                    console.log('get error', error);
                });
        },

        initActions() {
            this.setActive();
            const url = '/recept/api/favourite/check/' + this.userId + '/' + this.recipeId;

            axios
                .get(url)
                .then((response) => {
                    this.favourite = response.data.favourite;
                })
                .catch((error) => {
                    console.log('get error', error);
                });
        },

        handleOutsideClick(e) {
            if (!this.$el.contains(e.target)) this.active = false;
        }
    }
};
</script>
